import { useEffect, useState } from 'react';
import { db } from 'utils/firebase';
import useRestaurant from 'CustomHooks/useRestaurant';
import {
  normalizeVatTaxCountry,
  VatTaxCountry,
} from 'types/shared/helper/eventVatComponents';

export type RestaurantVatCountry = {
  loaded: boolean;
  /** Supported tax country of the published address, or null (never a DE default). */
  country: VatTaxCountry | null;
  /** Stored value, to explain an unsupported country such as "ES". */
  stored: string;
};

/** Live country of `restaurants/{id}/settings/address`, the same source the API uses. */
const useRestaurantVatCountry = (): RestaurantVatCountry => {
  const { restaurantId } = useRestaurant();
  const [state, setState] = useState<RestaurantVatCountry>({
    loaded: false,
    country: null,
    stored: '',
  });

  useEffect(() => {
    if (!restaurantId) return;
    return db
      .collection(`restaurants/${restaurantId}/settings`)
      .doc('address')
      .onSnapshot(
        (doc) => {
          const stored = String(doc.data()?.country ?? '').trim();
          setState({ loaded: true, country: normalizeVatTaxCountry(stored), stored });
        },
        () => setState({ loaded: true, country: null, stored: '' })
      );
  }, [restaurantId]);

  return state;
};

export default useRestaurantVatCountry;
